import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, LARGE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    letter: {
      fontWeight: 'bold',
      fontSize: 32,
      lineHeight: '38px',
      borderBottom: `3px solid ${colorsPalette.violetAnalyticsCard}`,
      paddingBottom: SMALL_MARGIN / 2,
      [theme.breakpoints.up('md')]: {
        fontSize: 40,
        lineHeight: '48px',
        marginBottom: LARGE_MARGIN,
      },
    },
    letterBlock: {
      width: '100%',
    },
    hitsBlock: {
      marginBottom: LARGE_MARGIN,
      display: 'flex',
      flexWrap: 'wrap',
      marginRight: `-${SMALL_MARGIN}px`,
      width: '100%',
      '& > div': {
        width: `calc((100% - ${SMALL_MARGIN * 3}px) / 3)`,
        marginRight: SMALL_MARGIN,
      },
    },
  }),
);

export default useStyles;
